<app-input-container [label]="label" [obrigatorio]="obrigatorio" [valorVazio]="valorVazio">
  <select #campo class="form-control form-control-sm" [name]="name" [(ngModel)]="value" autocomplete="off" [attr.disabled]="getAtivo()?null:'disableb'" (change)="seleciona()">
    <option translate value="" [selected]="value === ''">{{'dropDownList.selecionePlaceHolder'}}</option> 
    <option [translate]="getTranslate(item.texto)" *ngFor="let item of itens"  [value]="item.valor">{{item.texto}}</option>
  </select>
</app-input-container>